import React from 'react';
import { Typography } from 'fronton-react';
import { PravilaUslug } from './pravila-uslug';
import { RulesTemplate } from './rules-template';
import { PageProps } from './types';

export const CurrentPage = ({ title, path }: PageProps) => {
	let PageContent;
	switch (path) {
		case '/pravila/uslugi/':
			PageContent = <PravilaUslug />;
			break;
		default:
			PageContent = <RulesTemplate />;
			break;
	}

	return (
		<div>
			<Typography variant="h1" as="h1" data-qa="staticPageTitle" color="text-primary">
				{title}
			</Typography>
			{PageContent}
		</div>
	);
};
